import { initialState } from "./initialState";

export const alteredState = initialState;
